import { Container, ContainerGutter, ContainerPadding, Text, TokenTextAppearance, TextTag } from '@volkswagen-onehub/components-core';
import { Calc } from '@volkswagen-onehub/icons-core';
import { FocusLayerSizeV2 } from '@volkswagen-onehub/layer-manager';
import React, { useContext } from 'react';
import { LayerContext, useFocusLayer } from '../../../../Layers';
import { CustomDetailsCTA } from '../../../../styles/components';
import { getLang, getTranslations } from '../../../../translations';
import { DealerData, VehicleData } from '../../../../types';
import { LayerCloseHandle } from '../../../../types/layers';
import { useFeatureServices } from '../../../../use-feature-services';
import { VehicleDetailsContext } from '../../../../utils/details-context';
import { createConfiguration, createConstantData, createPartner, createProcess } from '../../../../utils/get-tracking-event-data';
import SelectedPaymentSummary from '../SelectedPaymentSummary';
import EstimatesModal from './EstimatesModal';

export default () => {

    const trans = getTranslations();
    const { tracking } = useFeatureServices();
    const context = useContext(VehicleDetailsContext)
    const vehicle = context.vehicle as VehicleData;
    const dealer = context.dealer as DealerData;
    const lang = getLang();
    const { closeLayer } = useContext(LayerContext);
    const openPaymentEstimatorLayer = useFocusLayer('payment-estimator-layer', {
      size: FocusLayerSizeV2.C,
      onClose: () => closeLayer('payment-estimator-layer')
    });

    const handleCTAClick = (e: React.SyntheticEvent<HTMLButtonElement>) => {

      openPaymentEstimatorLayer((close) => <EstimatesModal vehicle={vehicle} dealer={dealer} close={close as unknown as LayerCloseHandle} />)

      tracking.track('VWBasic_Button_Click', {
        ...createConstantData(),
        configuration: createConfiguration('VWBasic_Button_Click', vehicle, lang),
        partner: createPartner(dealer),
        process: createProcess("3"),
        link: {
          link: window.location.href,
          name: e.currentTarget.innerText
        }
      });
    };

    return (
        <Container
            padding={{ top: ContainerPadding.dynamic0040, bottom: ContainerPadding.dynamic0040 }}
            stretchContent
            wrap="always"
            gutter={ContainerGutter.static300}>
                <Text key={1} tag={TextTag.p} appearance={TokenTextAppearance.headline100} bold>{trans.details.summary.payment}</Text>
                <Text key={2} tag={TextTag.p} appearance={TokenTextAppearance.copy200}>{trans.details.summary.monthly_payment}</Text>

                <CustomDetailsCTA
                    key={3}
                    tag="button"
                    emphasis="tertiary"
                    onClick={(e: React.SyntheticEvent<HTMLButtonElement>) => handleCTAClick(e)}
                    ariaLabel="Estimates payment"
                    icon={<Calc ariaLabel={trans.labels.calculator_icon} />}
                    iconPosition="start"
                >
                    <Text bold>{trans.details.details_payment_estimator}</Text>
                </CustomDetailsCTA>

                <SelectedPaymentSummary />
        </Container>
    );
}
